import { render, staticRenderFns } from "./DebugInfo.vue?vue&type=template&id=651c69f8"
import script from "./DebugInfo.vue?vue&type=script&lang=js"
export * from "./DebugInfo.vue?vue&type=script&lang=js"
import style0 from "./DebugInfo.vue?vue&type=style&index=0&id=651c69f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports